module.exports = __webpack_public_path__ + "static/media/magnifiying-glass.58996999.svg";